import { IMediaFile } from '@src/models/api';
import { parseISO } from 'date-fns';

export const getIsImage = (file: IMediaFile) => !file.previewUrl?.includes('cdn.centra.ai/app-static/o/mime_icon/');

export const getCreationDate = (message, attachedFilesHistory, files, activeIndex) => {
  if (message) {
    return parseISO(message.createdAt);
  }
  if (attachedFilesHistory && files[activeIndex]?.message) {
    return parseISO(files[activeIndex]?.message?.createdAt as string);
  }
  return undefined;
};
